import Keycloak from 'keycloak-js'
export interface AuthState {
  keycloak: Keycloak | null
  authenticated: boolean
  username: string | null
  token: string | null
  loading: boolean
  error: string | null
  roles: string[]
  user?: any | null
}
export interface KeycloakConfig {
  url?: string
  realm: string
  clientId: string
  clientSecret: string
  clientIdAdmin: string
  clientSecretAdmin: string
  adminUrl: string
  registerUrl: string
  adminPassword: string
  adminUsername: string
}
export enum UserRole {
  ADMIN = 'ADMIN',
  RSSI = 'RSSI',
  SSI_TEAM = 'SSI',
  DSSI = 'DSSI',
  IT = 'IT',
  OTHERS = 'Autres',
}
